<template>
  <svg
    style="enable-background: new 0 0 48 48"
    version="1.1"
    viewBox="0 0 48 48"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="_x34_8x48" />
    <g id="icons">
      <g>
        <ellipse class="st1" cx="24.5" cy="24.5" rx="3.5" ry="3.5" />
        <path
          class="st1"
          d="M27.3,31c2.4,1.7,16.6,5.7,19.2-3.5c2.6-9.1-5.2-15.2-8.7-10.9c-0.3,0.3-0.8,1.5-1.8,2.6"
        />
        <path
          class="st1"
          d="M18.1,27.3c-1.7,2.4-5.7,16.6,3.5,19.2c9.1,2.6,15.3-5.1,10.9-8.7c-0.2-0.2-0.8-0.5-1.4-0.9"
        />
        <path
          class="st1"
          d="M21.7,18c-2.4-1.7-16.6-5.7-19.2,3.5c-2.6,9.1,5.2,15.2,8.7,10.9c0.2-0.2,0.5-0.7,0.9-1.4"
        />
        <path
          class="st1"
          d="M30.9,21.7c1.7-2.4,5.7-16.6-3.5-19.2c-9.1-2.6-15.3,5.1-10.9,8.7c0.2,0.2,0.8,0.5,1.4,0.9"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "FanIcon",
};
</script>

<style lang="stylus" scoped>
.fanIcon {
  fill: currentColor;
}

path, ellipse {
  stroke: currentColor;
}

.st0 {
  fill: none;
  stroke-width: 4;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}

.st1 {
  fill: none;
  stroke-width: 4;
  stroke-miterlimit: 10;
}

.st2 {
  fill: none;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
</style>
